export const FAVORITE_TEAM_SPORT = 'Soccer';
export const FAVORITE_TEAMS_ALL_ROUT = 'all';
export const FAVORITE_TEAM_SPORT_ID = 1;
